import React, {ReactNode} from 'react';
import classNames from 'classnames';
import {Link} from 'react-router-dom';
import atify from '../../lib/atify.ts';
import profileUrl from '../../lib/profileUrl.ts';
import {Avatar, Creator} from './CreatorIdentity.tsx';
import {isNotNullOrWhiteSpace} from '../../lib/isNullOrWhiteSpace.ts';

interface PersonCardProps {
    creator: Creator;
    // "5 public projects", "Teacher", a role in the group.
    detail?: string;
    // Extra badges or an action; "View portfolio" is added by default.
    children?: ReactNode;
    className?: string;
}

const PersonCard: React.FC<PersonCardProps> = ({
    creator,
    detail,
    children,
    className
}) => {
    const handle = atify(creator.nickname);

    return (
        <div className={classNames('mx-person-card', className)}>
            <Avatar creator={creator} size="m" />
            <div className="mx-person-text">
                <span className="mx-person-name">
                    {isNotNullOrWhiteSpace(creator.name) ? creator.name : handle}
                </span>
                <span className="mx-person-detail">
                    {isNotNullOrWhiteSpace(creator.name) && handle}
                    {isNotNullOrWhiteSpace(creator.name) && detail && ' · '}
                    {detail}
                </span>
            </div>
            {children ?? (
                <Link
                    to={profileUrl(creator.nickname)}
                    className="btn btn-secondary btn-sm"
                >
                    View portfolio
                </Link>
            )}
        </div>
    );
};

export default PersonCard;
